import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

export enum HorizontalAlignment {
  'LEFT' = 'left',
  'RIGHT' = 'right',
  'CENTER' = 'center',
}
@Component({
  standalone: true,
  selector: 'app-img-card',
  templateUrl: './img-card.component.html',
  styleUrls: ['./img-card.component.css'],
  imports: [CommonModule],
})
export class ImgCardComponent {
  @Input() imageUrl: string;
  @Input() backgroundColor: string | undefined;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() aspectRatio = '16/9';
  @Input() tag: string;
  @Input() tagColor = '#4D5154';
  @Input() alignment = HorizontalAlignment.CENTER;

  private readonly _sanitizer = inject(DomSanitizer);

  backgroundUrl(): SafeStyle {
    return this._sanitizer.bypassSecurityTrustStyle(`url(${this.imageUrl})`);
  }
}
